import React from "react"
import dayjs from "dayjs"
import HowToRegIcon from "@mui/icons-material/HowToReg"
import { goBack } from "react-router-redux"
import { useDispatch } from "react-redux"
import GenericTopBarHeader from "../../components/GenericTopBarHeader"
import PageHeaderTitle from "../../components/PageHeaderTitle"
import { COLORS } from "../../utils"
import { useSelector } from "react-redux"
import { CircularProgress } from "@mui/material"
import { getAlertsLoadingSelector } from "../../reducers/Alerts/alerts"

const AlertsLayout = ({ children, date = dayjs.utc().format("DD/MM/YYYY") }) => {
    const loading = useSelector(getAlertsLoadingSelector)
    
    const dispatch = useDispatch()

    const handleGoBack = () => {
        dispatch(goBack())
    }

    return (
        <div className="flexColumn flex1 stretchSelf">
           {/* ----------- header ----------- */}
            <GenericTopBarHeader
                title={(
                    <PageHeaderTitle
                        icon={<HowToRegIcon />}
                        title="Supervision / Alertes"
                        color={COLORS.PRIMARY_COLOR}
                        subtitle={date}
                    />
                )}
                onBack={handleGoBack}
                rightAction={loading ? <CircularProgress /> : null}
                sx={{ height: 64, position: "sticky", top: 0, zIndex: 11, backgroundColor: COLORS.WHITE, alignSelf: "stretch" }}
            />
            <div className="flexColumn flex1 stretchSelf">
            {children}
            </div>
        </div>
    )
}

export default AlertsLayout
